<template>
   <div class="BoardDetailsx">
      <div class="board">
        <div class="columns">
            <div class="column is-one-fifth">
              <h3 class="title is-4">dataset / {{ dataset.id}}
                <b-tag type="is-success is-light" v-if="dataset.public">
                  hub
                </b-tag> 
              </h3>
            </div>
            <div class="column is-four-fifths">
              <h3 class="title is-4">
                {{ stepName(stepId) }}
              </h3>
            </div>
        </div>
        <!-- <b-breadcrumb
            separator="has-arrow-separator"
        >
            <b-breadcrumb-item href="/">Dashboard</b-breadcrumb-item>
            <b-breadcrumb-item href="/documentation">{{dataset.name}}</b-breadcrumb-item>
            <b-breadcrumb-item href="/documentation/breadcrumb" active>{{ stepName(stepId) }}</b-breadcrumb-item>
        </b-breadcrumb> -->
        
         <div class="columns">
            <div class="column is-one-fifth">
               <b-menu>
                  <b-menu-list label="" >
                    
                    <b-progress 
                    v-if="dataset.is_uploading_data" 
                    size="is-small" type="is-success" show-value>
                    Wait. Uploading and processing
                  </b-progress>

                     <b-menu-item v-for="item in getItems()" :key="item.id"
                      :label="item.name"
                      :active="stepId === item.id || (stepId === undefined && item.id === 'analysis')"
                      tag="router-link"
                      :to="'/datasets/'+ dataset.id +'/'+ item.id">
                     </b-menu-item>
                     
                  </b-menu-list>
               </b-menu>
            </div>
            <div class="column">
               <div class="page-info" >


                    <div class="columns" v-if="dataset">
                        <br>
                        
                        <br>
                        <div class="column is-full">
                          <b-loading 
                            :is-full-page="true" 
                            :v-model="(dataset.is_analyzing || dataset.is_uploading_data)" 
                            :can-cancel="false">
                          </b-loading>
                          <Analysis :dataset="dataset" v-if="stepId == 'analysis' || stepId == undefined"/>
                          <Labeling :dataset="dataset" v-if="stepId == 'labeling'"/>
                          <!-- <Errors :dataset="dataset" v-if="stepId == 'errors'"/> -->
                          <HumanLabelers :dataset="dataset" v-if="stepId == 'human-labeling'"/>
                          <DataQuality :filterId="filterId" :dataset="dataset" :wordclouds="datasetWordcloud" :currentUser="currentUser" v-if="stepId == 'data'"/>
                          <Config :dataset="dataset" v-if="stepId == 'settings' && !hiddenSettings()" :currentUser="currentUser"/>
                        </div>
                        
                    </div>

                </div>
            </div>
         </div>

      </div>
   </div>
</template>

<script>
import Analysis from "@/dashboard/Dataset/Analysis.vue";
import DataQuality from "@/dashboard/Dataset/DataQuality.vue";
import Config from "@/dashboard/Dataset/Config.vue";
import Labeling from "@/dashboard/Dataset/Labeling.vue";
import HumanLabelers from "@/dashboard/Dataset/HumanLabelers.vue";
import Errors from "@/dashboard/Dataset/Errors.vue";

// import { Plotly } from 'vue-plotly'

   export default {
     props: ["datasetId","stepId","filterId"],
     name: "DatasetDetails",
     data: () => {
       return {
        currentTab: null,
        show_plots: false,
        
        items: [
          
          {
            name: "Data", id: "data"
          },
          {
            name: "Labeling", id: "labeling"
          },
          {
            name: "Analysis", id: "analysis"
          },
          {
            name: "Error Analysis", id: "errors"
          },
          {
            name: "Human Labeling Service Request", id: "human-labeling"
          },
          {
            name: "Settings", id: "settings"
          }
        ]
       }
     },
     components: {
       Analysis,
       DataQuality,
       Config,
       Labeling,
       HumanLabelers,
       Errors
     },
     computed: {
       dataset() {
         return this.$store.state.dataset;
       },
       datasetWordcloud() {
         return this.$store.state.datasetWordcloud;
       },
       currentUser() {
         return this.$store.state.currentUser;
       }
     },
     filters: {
      capitalize: function (value) {
        if (!value) return ''
        let name = this.items.filter(x => x.id == value)
        
        name = name.toString().replace("-", " ")
        return name.charAt(0).toUpperCase() + name.slice(1)
      }
    },
     methods:{
       stepName(stepId){
          stepId = (stepId == undefined)?'data':stepId
          return this.items.filter(x => x.id == stepId)[0].name
       },
       hiddenSettings(){
         if (this.currentUser){
            return (this.dataset.public && (this.dataset.userId != this.currentUser.id))
        } else {
          return true
        }
       },
       getItems(){
         let items = this.items
         if (this.hiddenSettings()){
            items = items.filter(x => 
                x.id !== 'settings'
            )
         }
         items = items.filter(x => 
              x.id !== 'human-labeling'
          )
         return items
       },
       create_data_plots(){
         this.statistics = JSON.parse(
          '{"label":{"0":"ForadeContexto","1":"ConfirmaSer","2":"Irritado","3":"Falecido","4":"AlegaPagamento","5":"ClienteNaoDisponivel \\/ Recado","6":"PromessaPagamento","7":"SolicitaFacilitacao","8":"NaoRecebeuBoleto","9":"NaoPretendePagar","10":"NaoConhece","11":"EnviarBoleto","12":"ProblemasFinanceiros","13":"Desconfian\\u00e7a\\/Fraude","14":"DuvidaSerasa","15":"Judicial cliente","16":"Judicial n\\u00e3o cliente"},"count":{"0":150,"1":150,"2":294,"3":197,"4":234,"5":151,"6":279,"7":172,"8":198,"9":150,"10":190,"11":246,"12":279,"13":150,"14":151,"15":153,"16":150},"mean":{"0":13.4733333333,"1":23.0133333333,"2":34.612244898,"3":35.0456852792,"4":35.5299145299,"5":36.5894039735,"6":37.6630824373,"7":40.5930232558,"8":40.8585858586,"9":41.12,"10":43.0105263158,"11":44.0894308943,"12":49.6845878136,"13":55.2266666667,"14":59.7748344371,"15":60.522875817,"16":75.48}}'
        )

        this.data_plot = [{
          labels: Object.values(this.statistics['label']),
          values: Object.values(this.statistics['count']),
          type:"pie"
        }]

        this.data_plot_bar = [{
          x: Object.values(this.statistics['label']),
          y: Object.values(this.statistics['mean']),
          type: 'bar'
        }]

        this.layout = {
          title: "Label percentages",
          colorway : ['#f3cec9', '#e7a4b6', '#cd7eaf', '#a262a9', '#6f4d96', '#3d3b72', '#182844']
        }

        this.layout_bar = {
          title: "Average Text Length by Label"
        }

        this.show_plots = true
       }
     },
     mounted(){
       
     },
     created() {
       if (this.stepId == ""){
         this.stepId = "data"
       }
       this.$store.dispatch("currentDataset", this.datasetId);
       this.$store.dispatch("currentUser");



     },
   };
</script>

<style lang="scss" scoped>
.BoardDetails {
  .board {
    .items {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 16px;

      .item {
        position: relative;

        &:hover {
          .actions {
            display: unset;
          }
        }

        a {
          color: inherit;
          text-decoration: none;
        }

        .image-container {
          width: 100%;
          padding-top: 56.25%;
          overflow: hidden;
          background: #dedede;
          position: relative;
          border-radius: 4px;
          box-shadow: 1px 1px 1px #adadad;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        .info {
          margin-top: 12px;

          .title {
            display: block;
            margin-bottom: 4px;
            text-transform: capitalize;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .description {
            margin: 0;
            margin-bottom: 8px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .hostname {
            display: block;
            color: #a3a3a3;
          }
        }

        .actions {
          position: absolute;
          display: none;
          right: 0;
          top: 0;
          margin: 8px;

          .action {
            border: solid 1px black;
            padding: none;
            background: white;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            outline: none;
          }
        }
      }
    }
  }
}
</style>
